var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 75,
    viewBox: "0 0 92 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_702_166)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.9579 11.7402V6.01929H68.6831V0.751465H45.5225V6.01929H54.2477V11.7402C35.4839 13.1941 21.5396 28.4076 23.1156 45.7282C24.6916 63.0383 41.1827 75.9023 59.9579 74.4484C78.7216 72.9945 92.6659 57.781 91.0899 40.4604C89.6966 25.1626 76.5403 13.0255 59.9579 11.7402ZM57.1028 69.307C41.4225 69.307 28.7116 57.5808 28.7116 43.1153C28.7116 28.6499 41.4225 16.9237 57.1028 16.9237C72.7716 16.9237 85.4711 28.6288 85.4939 43.0837C85.4939 57.5597 72.7944 69.2965 57.1028 69.307Z",
    fill: "#00755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7473 27.0171H53.0371V47.1297L72.9543 47.2877L72.9657 42.0199L58.7473 41.8829V27.0171Z",
    fill: "#00755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1192 40.4497H0V45.7175H17.1192V40.4497Z",
    fill: "#00755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5066 53.5034H5.7793V58.7712H19.5066V53.5034Z",
    fill: "#00755F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6208 27.1641H5.7793V32.4319H19.6208V27.1641Z",
    fill: "#00755F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_702_166"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.2034,
    height: 73.8023,
    fill: "white",
    transform: "translate(0 0.751465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimer);
export default __webpack_public_path__ + "static/media/timer.191003baf05d48baddce91f291310ec5.svg";
export { ForwardRef as ReactComponent };